<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.charge_sp11')"
    width="900px"
    :close-on-click-model="false"
    class="charge-share-dialog"
  >
    <div class="charge-share-dialog-inner">
      <el-form :inline="true" label-width="72px" label-position="left">
        <el-form-item v-if="charges.length > 1">
          <span slot="label" style="font-weight: bold">
            {{ $t('FinanceManage.allocationType') }}
            <el-tooltip
              effect="light"
              :content="$t('Message.ShareTypeTip')"
              placement="bottom-start"
            >
              <img :src="iconQuestion" width="13" height="13" style="cursor:pointer;padding: 2px 2px 0 0;">
            </el-tooltip>
          </span>
          <el-radio-group v-model="shareType" @change="shareTypeChange">
            <el-radio :label="0">{{ $t('Message.Agreement') }}</el-radio>
            <el-radio :label="1">{{ $t('Message.NotAgreement') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-right: 0;">
          <span slot="label" style="font-weight: bold">
            {{ $t('Message.AllocationNature') }}
            <el-tooltip
              effect="light"
              :content="$t('Message.VirtualAllocationAndActualSplitTip')"
              placement="bottom-start"
            >
              <img :src="iconQuestion" width="13" height="13" style="cursor:pointer;padding: 2px 2px 0 0;">
            </el-tooltip>
          </span>
          <el-radio-group :value="shareNature" @input="onShareNatureInput">
            <el-radio :label="0">{{ $t('Message.VirtualAllocation') }}</el-radio>
            <el-radio :label="1">{{ $t('Message.ActualSplit') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <span v-if="shareNature===1" style="color: red">{{ $t('Message.ActualSplitWarn') }}</span>
      </el-form>
      <el-card :header="title" shadow="never">
        <cargo-ag-grid
          :grid-options="costTable.grid.gridOptions"
          :column-defs="dynamicCostColumnDefs"
          :row-data="charges"
          min-height="150px"
          @gridReady="params=>{costTable.grid.gridApi=params.api}"
        />
      </el-card>
      <el-card :header="$t('FinanceManage.separateAllocation')" shadow="never">
        <div style="padding-bottom: 10px;">
          <el-button :disabled="controlCalcButton" type="primary" @click="calcShareAmount()">{{ $t('CargoMsg.Cargo_CalcShareAmount') }}</el-button>
        </div>
        <div style="display: flex;">
          <cargo-ag-grid
            :grid-options="sharingTable.grid.gridOptions"
            :column-defs="dynamicSharingColumnDefs"
            :row-data="sharingTable.grid.rowData"
            style="min-height:200px;"
            @gridReady="params=>{sharingTable.grid.gridApi=params.api}"
          />
          <cargo-ag-grid
            v-show="sharingDetailTable.grid.isShow"
            :grid-options="sharingDetailTable.grid.gridOptions"
            :column-defs="dynamicShareDetailColumnDefs"
            :row-data="sharingDetailTable.grid.rowData"
            :show-side-bar="false"
            style="min-height:200px;margin-left: 2px;"
          />
        </div>
      </el-card>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="enterHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import iconQuestion from '@/assets/icon-question.png'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { chargeShare } from '@/api/seaExport/seaExportJob'
import { cache, cacheName } from '@/utils/cacheManager'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroupHP'
import { SHARE_CHARGE_SCHEMES, SHARE_CHARGE_SCHEMES_NEW } from '@/class/cargo/model/parameters/ChargeConstants'
import { deepClone, formatNumberToThousands } from '@/utils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { Charge } from '@/class/model/act/Charge'
import { roundHalfUp, ensureExecuteSuccess } from '@/utils/commonUtil'
import { queryContainerNoByLclMasterUuid } from '@/api/booking/job'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getObjectByCache } from '@/utils/basicDataCache'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { Company } from '@/class/model/mdm/Company'
import lodash from 'lodash'
import * as NumberUtils from '@/utils/NumberUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BillType from '@/class/cargo/model/parameters/BillType'

export default {
  name: 'ChargeShareDialog',
  props: {
    visible: { type: Boolean, require: true },
    job: { type: Object, default: () => ({}) },
    charges: { type: Array, default: () => [] },
    diffChargeKeys: { type: Array, default: () => [] },
    location: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: this.visible,
      iconQuestion,
      shareType: 0, // 分摊类型：0一致 1不一致
      shareNature: 0, // 分摊性质：0虚拟分摊 1真是拆分
      title: '',
      costTable: {
        grid: {
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            suppressRowClickSelection: true,
            singleClickEdit: true,
            frameworkComponents: {
              CargoAgGridSelectEditor
            },
            context: {
              componentParent: this
            }
          },
          gridApi: null
        }
      },
      controlCalcButton: false, // 判断是否都是是手动分配/不分配
      isClickCalc: false, // 是否需要点击计算分摊金额按钮
      sharingTable: {
        grid: {
          gridOptions: {
            rowSelection: 'multiple',
            suppressCellSelection: true,
            suppressRowClickSelection: true,
            singleClickEdit: true,
            frameworkComponents: {
              CargoAgGridCommonInputEditor
            },
            onRowSelected: params => {
              if (!this.controlCalcButton) {
                this.isClickCalc = true
              }
            },
            onCellFocused: event => {
              this.shareSelectedRowIndex = event.rowIndex
              const nodes = event.api.rowModel.rowsToDisplay
              const selectedNode = nodes[event.rowIndex] || null
              this.sharingTable.grid.selectedNode = selectedNode
              if (selectedNode && this.sharingDetailTable.grid.isShow) {
                this.showShareChargeDetail(true, selectedNode.data.uuid)
              }
            },
            onSortChanged: event => {
              if (this.sharingTable.grid.selectedNode) {
                event.api.setFocusedCell(this.sharingTable.grid.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
              }
            },
            context: {
              componentParent: this
            }
          },
          rowData: [],
          gridApi: null,
          selectedNode: null,
          amountColumn: {
            editable: false
          }
        }
      },
      sharingDetailTable: {
        grid: {
          isShow: false,
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            suppressRowClickSelection: true,
            singleClickEdit: true,
            frameworkComponents: {
              CargoAgGridAdvanceSelectEditor
            },
            context: {
              componentParent: this
            }
          },
          rowData: []
        }
      },
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        customerTitlesMap: new Map(),
        customerSettlementAgentMap: new Map() // 结算对象关联的结算代理
      },
      slaveJobChargeAccountsMap: new Map(),
      shareSelectedRowIndex: -1,
      jobMap: new Map(), // job分摊费用汇总信息
      chargeMap: new Map() // （分摊的）费用信息
    }
  },
  computed: {
    charge() {
      return this.charges[0] || {}
    },
    dynamicCostColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          field: 'chargeItemId',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementCompany'),
          field: 'accountId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'currency',
          width: 90
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Amount'),
          field: 'amount',
          width: 100
        },
        {
          headerName: this.$t('FinanceManage.allocationType'),
          field: 'shareScheme',
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.shareSchemeFunc(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: this.charges.length > 1 ? SHARE_CHARGE_SCHEMES_NEW : SHARE_CHARGE_SCHEMES,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          onCellValueChanged: p => { this.shareShemeChange(p) }
        }
      ]
    },
    dynamicSharingColumnDefs() {
      const result = [
        {
          headerName: '', width: 45, checkboxSelection: true, headerCheckboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_JobNo'),
          field: 'jobNo',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerNo'),
          field: 'containerNo',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SeparateNumber'),
          field: 'hblNbr',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Package') + this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantity',
          width: 150,
          hide: true,
          valueFormatter: params => {
            return params.data.quantityActual || params.data.quantityContract || 0
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AmountNumber'),
          field: 'shareQuantity',
          width: 130,
          hide: true,
          cellRenderer: (params) => {
            return (!params || !params.data || !params.data.shareQuantity) ? 0 : ColumnUtils.roundHalfUp(params.data.shareQuantity, 3)
          }
        }, {
          headerName: this.$t('Message.SharedChargeTotal'),
          field: 'shareAmount',
          width: 150,
          valueFormatter: params => {
            return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2))
          },
          editable: this.sharingTable.grid.amountColumn.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => { this.gridItemEditorSessionSaveHandler(p) }
        }
      ]
      if ((this.charges.length > 0 && !this.controlCalcButton) || this.charges.length > 1) {
        result.push({
          headerName: '',
          field: 'showDetail',
          minWidth: 30,
          width: 30,
          cellRenderer: params => {
            return `<i class="${params.value ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'}" style="color:blue"></i>`
          },
          onCellClicked: params => {
            const data = params.data
            if (data.showDetail) {
              for (const row of this.sharingTable.grid.rowData) {
                row.showDetail = false
              }
            } else {
              for (const row of this.sharingTable.grid.rowData) {
                row.showDetail = true
              }
            }
            params.api.refreshCells({ force: true })
            this.showShareChargeDetail(data.showDetail, data.uuid)
          }
        })
      }
      return result
    },
    dynamicShareDetailColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          field: 'chargeItemId',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'),
          field: 'accountId',
          colId: 'accountId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          editable: this.shareNature === 0 ? this.charge.receivable : true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true },
              autoKey: 'auto_0',
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                return true
              },
              filterable: true,
              clearable: false
            }
          },
          onCellValueChanged: p => this.onCellAccountId(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'currency',
          width: 90
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Amount'),
          field: 'amount',
          width: 100
        }
      ]
    },
    shareSelectedRow() {
      return this.sharingTable.grid.rowData[this.shareSelectedRowIndex]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.shareType = 0
        this.shareNature = 0
        this.isClickCalc = false
        this.sharingTable.grid.rowData = []
        this.sharingDetailTable.grid.isShow = false
      }
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
    if (this.visible) {
      this.init()
    }
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.title = this.$t('SeaExport.MasterBillNo') + ':' + this.mawbNoDispalyFormat(this.job.mbl)
      this.resetControlCalcButton()
      if (ChargeUtils.getChargeWeightValueType(false) === 2 && ['SE', 'SI'].includes(this.job.lob)) {
        // 这里取最新的小票数据，以及相关费用、提单
        await JobUtils.getSlaveChargeCargoDoc(this.job)
      } else {
        // 这里取最新的小票数据，以及相关费用
        await JobUtils.getLclSlavesAndCharges(this.job)
      }
      await this.loadSlavesAndChargeResultHandler()
      this.loadSlaveJobChargeAccountsMap()
      this.sharingTable.grid.amountColumn.editable = this.charges.length === 1 && this.charge.shareScheme === ChargeConstants.SHARE_HANDWORK.code
      this.$nextTick(async() => {
        await ensureExecuteSuccess(() => this.costTable.grid.gridApi)
        this.shareTypeChange()
        await ensureExecuteSuccess(() => this.sharingTable.grid.gridApi)
        this.sharingTable.grid.gridApi.selectAll()
      })
    },
    // 对11位的mawbNo进行显示的格式化，比如78100000066格式化化为781-0000-0066
    mawbNoDispalyFormat(mawbNo) {
      if (mawbNo && mawbNo.length === 11) {
        mawbNo = mawbNo.substr(0, 3) + '-' + mawbNo.substr(3, 4) + ' ' + mawbNo.substr(7)
      }
      return mawbNo
    },
    // 重置controlCalcButton
    resetControlCalcButton() {
      const index = this.charges.findIndex(p => p.shareScheme !== ChargeConstants.NOT_SHARED.code && p.shareScheme !== ChargeConstants.SHARE_HANDWORK.code)
      this.controlCalcButton = index < 0
    },
    // 加载小票及费用
    async loadSlavesAndChargeResultHandler() {
      const containerNoMap = await queryContainerNoByLclMasterUuid(this.job.uuid).then((res) => {
        return res.data || {}
      })
      this.job.lclSlaves = this.job.lclSlaves.map(item => {
        return { ...item, containerNo: containerNoMap[item.uuid] || '', shareAmount: 0, shareExcludingTaxAmount: 0, showDetail: false }
      })
      await this.hblHandler()
      this.sharingTable.grid.rowData = this.job.lclSlaves
      // 进来必须点击计算费用金额才可用点确认
      if (!this.controlCalcButton) {
        this.isClickCalc = true
      }
    },
    // 分单号处理
    async hblHandler() {
      for (const job of this.job.lclSlaves) {
        if (job.lob === 'SI' || job.lob === 'AI') {
          job.hblNbr = job.hbl
          continue
        }
        const jobClass = JobUtils.getJobByType(job)
        await jobClass.getCargoDoc()
        if (!jobClass.cargoDoc || jobClass.cargoDoc.length <= 0) return
        for (const doc of jobClass.cargoDoc) {
          if ((job.lob === 'SE' && doc.docType === 'HBL') || (job.lob === 'AE' && doc.docType === 'HAWB')) {
            job.hblNbr = doc.hblNbr2
            break
          }
        }
      }
    },
    shareTypeChange() {
      if (this.shareType === 0) {
        for (const item of this.charges) {
          if (item.shareScheme !== this.charge.shareScheme) {
            this.shareShemeChange({ data: this.charge })
            break
          }
        }
      }
    },
    onShareNatureInput(val) {
      if (val === 1) {
        for (const charge of this.charges) {
          if (charge.billingUuid || charge.invoiceUuid || (charge.paidOff || charge.verifiedAmount !== 0) || charge.billingPaymentUuid ||
            charge.agentSharedBillingUuid || charge.confirmBillUuid || this.diffChargeKeys.indexOf(charge.uuid) > -1) {
            this.$message.error(this.$t('Message.CannotActualSplitTip'))
            return
          }
        }
      }
      this.shareNature = val
    },
    // 分摊类型改变
    shareShemeChange({ data }) {
      if (this.shareType === 0) {
        for (const item of this.charges) {
          item.shareScheme = data.shareScheme
        }
        this.costTable.grid.gridApi.refreshCells({ force: true }) // 刷新
      }
      this.resetControlCalcButton()
      this.isClickCalc = true
      // 刷新分摊金额-这里只处理不分摊以及手动分摊
      if (this.controlCalcButton) {
        this.notShare()
      }
      this.sharingTable.grid.amountColumn.editable = this.charges.length === 1 && this.charge.shareScheme === ChargeConstants.SHARE_HANDWORK.code
      this.sharingTable.grid.gridApi.selectAll()
      this.sharingTable.grid.gridApi.refreshCells({ force: true }) // 刷新
    },
    // 不分摊
    notShare() {
      this.isClickCalc = false
      for (const job of this.job.lclSlaves) {
        job.shareAmount = 0
        job.shareQuantity = 0
        job.shareTaxAmount = 0
        job.shareExcludingTaxAmount = 0
      }
    },
    // 刷新分摊金额（不分摊以及手动分摊除外）
    calcShareAmount() {
      // 不分摊以及手动分摊直接跳出
      if (this.controlCalcButton) return

      const selectedRows = this.getSelectedRows(true)
      if (!selectedRows) return
      const tempMap = new Map()
      for (const selectedRow of selectedRows) {
        if (!tempMap.has(selectedRow.uuid)) {
          tempMap.set(selectedRow.uuid, selectedRow.uuid)
        }
      }
      for (const lclSlave of this.job.lclSlaves) {
        lclSlave.selected = false
        if (tempMap.has(lclSlave.uuid)) {
          lclSlave.selected = true
        }
      }
      this.isClickCalc = false
      // 是否进口业务
      const isImport = this.job && this.job.lob && (this.job.lob === 'SI' || this.job.lob === 'AI')
      this.jobMap = new Map() // 一个业务对应多个费用分摊详细
      this.chargeMap = new Map() // 一笔费用对应主票的所有小票
      const chargeGroup = this.groupingChargesByShareSheme()
      for (const [key, value] of chargeGroup.entries()) {
        switch (key) {
          case ChargeConstants.SHARE_AVERAGE.code:
            this.avgShare('average', value)
            break
          case ChargeConstants.SHARE_CHARGE_WEIGHT.code:
            this.avgShare('chargeWeight', value)
            break
          case ChargeConstants.SHARE_CUBAGE.code:
            this.avgShare(isImport ? 'cubageContract' : 'cubageActual', value)
            break
          case ChargeConstants.SHARE_WEIGHT.code:
            this.avgShare(isImport ? 'weightContract' : 'weightActual', value)
            break
          case ChargeConstants.SHARE_C_WEIGHT.code:// 根据实际计费重量只针对与空运订舱，其他三大业务点击无反应
            if (this.job.lob === 'AE') {
              this.avgShare('cWeight', value)
            } else {
              if (chargeGroup.size === 1) {
                this.notShare()
              }
            }
            break
          case ChargeConstants.SHARE_QUANTITY.code://  CARGO-5823海运进出口/空运进出口/铁路出口 根据件数分摊
            this.avgShare(isImport ? 'quantityContract' : 'quantityActual', value)
            break
          default: break
        }
      }
      if (this.sharingTable.grid.selectedNode && this.sharingDetailTable.grid.isShow) {
        this.showShareChargeDetail(true, this.sharingTable.grid.selectedNode.data.uuid)
      }
    },
    // 按分摊类型对费用进行分组
    groupingChargesByShareSheme() {
      const map = new Map()
      for (const charge of this.charges) {
        let subCharges = map.get(charge.shareScheme)
        if (!subCharges) {
          subCharges = []
          map.set(charge.shareScheme, subCharges)
        }
        subCharges.push(charge)
      }
      return map
    },
    // 选中的数据
    getSelectedRows(tips = true) {
      const chooseRows = this.sharingTable.grid.gridApi.getSelectedRows()
      if (tips && (!chooseRows || chooseRows.length <= 0)) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return null
      }
      return chooseRows
    },
    // 分摊类型更改-满足不分摊、手动分配
    avgShare(shareField = null, charges = []) {
      if (!this.controlCalcButton) {
        this.avgShareHandle(shareField, charges)
        return
      }
      this.sharingTable.grid.gridOptions.api.refreshCells({ force: true })
    },
    // 分摊类型更改处理
    avgShareHandle(shareField = null, charges = []) {
      for (const curCharge of charges) {
        const jobs = []
        let totalQuantity = 0
        if (shareField && shareField === 'average') {
          for (const job of this.job.lclSlaves) {
            if (!job.selected) continue // 这里只累计选中的总额
            job.shareQuantity = curCharge.quantity
            totalQuantity += 1
          }
        } else {
          let quantityCallback = (job) => job[shareField]
          if (ChargeUtils.getChargeWeightValueType(false) === 2) {
            switch (shareField) {
              case 'chargeWeight':
                quantityCallback = (job) => this.getQuantityByChargeWeightValueType2(job, 'chargeWeight', 'chargeWeight')
                break
              case 'cubageContract':
              case 'cubageActual':
                quantityCallback = (job) => this.getQuantityByChargeWeightValueType2(job, 'cubage', 'cubageActual')
                break
              case 'weightContract':
              case 'weightActual':
                quantityCallback = (job) => this.getQuantityByChargeWeightValueType2(job, 'weight', 'weightActual')
                break
              case 'quantityContract':
              case 'quantityActual':
                quantityCallback = (job) => this.getQuantityByChargeWeightValueType2(job, 'quantity', 'quantityActual')
                break
            }
          }
          for (const job of this.job.lclSlaves) {
            if (!job.selected) continue // 这里只累计选中的总额
            job.shareQuantity = quantityCallback(job) || 0
            totalQuantity += job.shareQuantity
          }
        }
        if (!curCharge.taxRate) curCharge.taxRate = 0
        let totalSharedAmount = 0.0
        for (let index = 0; index < this.job.lclSlaves.length; index++) {
          const job2 = this.job.lclSlaves[index]
          if (job2.selected && job2.shareQuantity && job2.shareQuantity !== 0) { // 这里只计算选中的业务
            if (shareField && shareField === 'average') {
              job2.shareQuantity = job2.shareQuantity / totalQuantity
            } else {
              job2.shareQuantity = job2.shareQuantity / totalQuantity * curCharge.quantity
            }
            // 这里需要判断单价是否含税
            // 是：
            //    不含税价 = (单价 * 数量) / (1 + (税率 / 100))
            //    含税价 = 单价 * 数量
            // 否：
            //    不含税价 = 单价 * 数量
            //    含税价 = (单价 * 数量) + ((单价 * 数量) * (taxRate / 100))
            if (index < this.job.lclSlaves.length - 1) {
              if (curCharge.unitPriceIncludeTax) {
                job2.shareAmount = roundHalfUp(RateUtil.getAmountByCurrency(curCharge.unitRate * job2.shareQuantity, curCharge.currency), 2)
                job2.shareExcludingTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(job2.shareAmount / (1 + (Number(curCharge.taxRate) / 100)), curCharge.currency), 2)
              } else {
                job2.shareExcludingTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(curCharge.unitRate * job2.shareQuantity, curCharge.currency), 2)
                job2.shareAmount = roundHalfUp(RateUtil.getAmountByCurrency(job2.shareExcludingTaxAmount + (job2.shareExcludingTaxAmount * Number(curCharge.taxRate) / 100), curCharge.currency), 2)
              }
              totalSharedAmount = totalSharedAmount + job2.shareAmount
            } else { // 最后一笔，直接保留两位小数，不要RateUtil.getAmountByCurrency这个函数，否则还是还会不平
              if (curCharge.unitPriceIncludeTax) {
                job2.shareAmount = roundHalfUp(curCharge.amount - totalSharedAmount, 2)
                job2.shareExcludingTaxAmount = roundHalfUp(job2.shareAmount / (1 + (Number(curCharge.taxRate) / 100)), 2)
              } else {
                job2.shareExcludingTaxAmount = roundHalfUp(curCharge.amount - totalSharedAmount, 2)
                job2.shareAmount = roundHalfUp(job2.shareExcludingTaxAmount + (job2.shareExcludingTaxAmount * Number(curCharge.taxRate) / 100), 2)
              }
            }
            job2.shareTaxAmount = Number(RateUtil.getAmountByCurrency(job2.shareAmount - job2.shareExcludingTaxAmount, curCharge.currency).toFixed(2))
          } else {
            job2.shareAmount = 0
            job2.shareExcludingTaxAmount = 0
            job2.shareQuantity = 0
            job2.shareTaxAmount = 0
          }
          this.setSlaveChargeShareAccountId(job2, curCharge)
          let tempJob = this.jobMap.get(job2.uuid)
          if (tempJob) { // 这里将相同uuid的分摊金额进行汇总
            tempJob.shareAmount += job2.shareAmount
            tempJob.shareExcludingTaxAmount += job2.shareExcludingTaxAmount
            tempJob.shareQuantity += job2.shareQuantity
            tempJob.shareTaxAmount += job2.shareTaxAmount
          } else {
            tempJob = {}
            tempJob.shareAmount = job2.shareAmount
            tempJob.shareExcludingTaxAmount = job2.shareExcludingTaxAmount
            tempJob.shareQuantity = job2.shareQuantity
            tempJob.shareTaxAmount = job2.shareTaxAmount
          }
          tempJob.uuid = job2.uuid
          this.jobMap.set(job2.uuid, tempJob)
          jobs.push(deepClone(job2))
        }
        this.chargeMap.set(curCharge.uuid, jobs)
      }
      // 汇总之后的分摊金额显示使用
      for (const job3 of this.job.lclSlaves) {
        const finalJob = this.jobMap.get(job3.uuid)
        if (!finalJob) continue
        job3.shareAmount = finalJob.shareAmount || 0
        job3.shareExcludingTaxAmount = finalJob.shareExcludingTaxAmount || 0
        job3.shareQuantity = finalJob.shareQuantity || 0
        job3.shareTaxAmount = finalJob.shareTaxAmount || 0
      }
      this.adjustAmountByPrecision(this.job.lclSlaves, 'shareAmount', 2)
      this.adjustAmountByPrecision(this.job.lclSlaves, 'shareExcludingTaxAmount', 2)
      this.validate(false)
      this.sharingTable.grid.gridOptions.api.refreshCells({ force: true })
    },
    // 获取【ChargeWeightValueType】为2的分摊数量
    getQuantityByChargeWeightValueType2(job, docField, jobField) {
      let doc = null
      if (['SE', 'SI'].includes(job.lob) && job.cargoDoc) {
        let mergeHbl = null
        let hbl = null
        let mergeMbl = null
        let mbl = null
        for (const doc of job.cargoDoc) {
          if (doc.docType === CargoDocConsts.HBL2 && job.typeHBL === BillType.MERGE_BILL_TYPE.code) {
            mergeHbl = doc
            break
          }
          if (doc.docType === CargoDocConsts.HBL) {
            hbl = doc
            continue
          }
          if (doc.docType === CargoDocConsts.MBL2 && job.typeMBL === BillType.MERGE_BILL_TYPE.code) {
            mergeMbl = doc
            continue
          }
          if (doc.docType === CargoDocConsts.MBL) {
            mbl = doc
            continue
          }
        }
        doc = mergeHbl || hbl || mergeMbl || mbl
      }
      return doc ? doc[docField] : job[jobField]
    },
    // 根据精度调整金额
    adjustAmountByPrecision(list, fieldName, precision) {
      const multiple = Math.pow(10, precision) // 倍数
      const minPrecision = 1 / multiple // 最小精度值
      const adjustList = []
      let totalRemainder = 0
      for (let i = 0; i < list.length; ++i) {
        const item = list[i]
        const floorValue = Math.floor(item[fieldName] * multiple) / multiple
        const remainder = item[fieldName] - floorValue
        adjustList.push({
          item,
          floorValue,
          remainder
        })
        totalRemainder += remainder
      }
      totalRemainder = Number(totalRemainder.toFixed(precision))
      adjustList.sort((a, b) => b.remainder - a.remainder) // 从大到小排序
      for (const e of adjustList) {
        if (totalRemainder > 0) {
          totalRemainder -= minPrecision
          e.item[fieldName] = e.floorValue + minPrecision
        } else {
          e.item[fieldName] = e.floorValue
        }
      }
    },
    // 多笔费用验证
    validate(tips = false) {
      const charges = this.charges.filter(p => p.shareScheme !== ChargeConstants.NOT_SHARED.code)
      if (charges.length > 0) {
        let total = 0 // 含税价
        let taxAmountTotal = 0 // 税额
        let exTaxAmountTotal = 0 // 不含税价
        let totalQuantity = 0 // 数量
        if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
          for (const job of this.job.lclSlaves) {
            if (!isNaN(job.shareAmount)) {
              total += Number(job.shareAmount)
            }
            if (!isNaN(job.shareTaxAmount)) {
              taxAmountTotal += Number(job.shareTaxAmount)
            }
            if (!isNaN(job.shareExcludingTaxAmount)) {
              exTaxAmountTotal += Number(job.shareExcludingTaxAmount)
            }
            if (!isNaN(job.shareQuantity)) {
              totalQuantity += Number(job.shareQuantity)
            }
          }
        }

        let chargeAmount = 0
        let chargeTaxAmount = 0
        let chargeExcludingTaxAmount = 0
        let chargeQuantity = 0
        for (const curCharge of charges) {
          chargeAmount += curCharge.amount
          chargeTaxAmount += curCharge.taxAmount
          chargeExcludingTaxAmount += curCharge.excludingTaxAmount
          chargeQuantity += curCharge.quantity
        }
        if (Math.abs(chargeAmount - total) > 0.1 && tips) {
          this.$message.error(this.$t('CargoMsg.Cargo_ShareChargeCheck'))
          return false
        }
        let lclSlave = this.job.lclSlaves[0]
        if (!this.controlCalcButton) {
          const selects = this.getSelectedRows(true)
          if (!selects) return
          lclSlave = selects[0]
        }
        if (Math.abs(chargeAmount - total) !== 0) {
          lclSlave.shareAmount = roundHalfUp(RateUtil.getAmountByCurrency(lclSlave.shareAmount + (chargeAmount - total), this.charge.currency), 2)
        }
        if (Math.abs(chargeTaxAmount - taxAmountTotal) !== 0) {
          const amount = lclSlave.shareTaxAmount
          lclSlave.shareTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(amount + (chargeTaxAmount - taxAmountTotal), this.charge.currency), 2)
        }
        if (Math.abs(chargeExcludingTaxAmount - exTaxAmountTotal) !== 0) {
          const amount = lclSlave.shareExcludingTaxAmount
          lclSlave.shareExcludingTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(amount + (chargeExcludingTaxAmount - exTaxAmountTotal), this.charge.currency), 2)
        }
        if (Math.abs(chargeQuantity - totalQuantity) !== 0) {
          const quantity = lclSlave.shareQuantity
          lclSlave.shareQuantity = roundHalfUp(RateUtil.getAmountByCurrency(quantity + (chargeQuantity - totalQuantity), this.charge.currency), 2)
        }
      }
      return true
    },
    // 更新费用分摊值的方法【这里默认填写的都是含税价】
    // 只有单条费用才会走这里，所以就用this.charge（就是数组中的第一条数据）
    gridItemEditorSessionSaveHandler(item) {
      let totalQuantity = 0 // 数量
      if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
        let temp = 0
        if (item && Number(item.newValue) !== 0) {
          for (const job of this.job.lclSlaves) {
            // 这里默认填写的都是含税价
            job.shareAmount = Number(job.shareAmount)
            job.shareQuantity = job.shareAmount / this.charge.unitRate
            job.shareExcludingTaxAmount = roundHalfUp(job.shareAmount / (1 + (Number(this.charge.taxRate) / 100)), 2)
            if (!isNaN(job.shareQuantity)) {
              totalQuantity += Number(job.shareQuantity)
            }
            job.shareTaxAmount = Number((job.shareAmount - job.shareExcludingTaxAmount).toFixed(2)) // 税额=含税金额-不含税金额。
          }
          temp = this.charge.quantity - totalQuantity
        } else {
          const uuid = item.data ? (item.data.uuid || '') : ''
          for (const job of this.job.lclSlaves) {
            if (job.uuid && uuid && job.uuid === uuid) {
              job.shareQuantity = 0
              job.shareAmount = 0
              job.shareTaxAmount = 0
              job.shareExcludingTaxAmount = 0
            }
          }
        }
        if (!temp) temp = 0
        if (Math.abs(temp) !== 0) {
          const quantity = this.job.lclSlaves[0].shareQuantity
          this.job.lclSlaves[0].shareQuantity = roundHalfUp(quantity + temp, 2)
        }
      }
      this.sharingTable.grid.gridOptions.api.refreshCells({ force: true })
    },
    showShareChargeDetail(isShow, jobUuid) {
      if (isShow) {
        const rowData = []
        const chargeAccountMap = this.slaveJobChargeAccountsMap.get(jobUuid)
        for (const charge of this.charges) {
          const jobs = this.chargeMap.get(charge.uuid)
          if (!jobs) {
            continue
          }
          const job = jobs.find(p => p.uuid === jobUuid)
          if (!job) {
            continue
          }
          rowData.push({
            uuid: charge.uuid,
            chargeItemId: charge.chargeItemId,
            accountId: (chargeAccountMap && chargeAccountMap.get(charge.uuid)) ? chargeAccountMap.get(charge.uuid) : charge.accountId,
            currency: charge.currency,
            amount: job.shareAmount
          })
        }
        this.sharingDetailTable.grid.rowData = rowData
        this.sharingDetailTable.grid.isShow = true
      } else {
        this.sharingDetailTable.grid.isShow = false
      }
    },
    // 保存
    async enterHandler() {
      let loading = getLoading4Cxt()
      if (this.isClickCalc) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CalcShareAmountTip'))
        loading.close()
        return
      }
      const data = {}
      const delUuids = [] // 删除费用的UUID
      const modCharges = [] // 要新增或修改的费用
      if (this.charges.length > 1) {
        for (const curCharge of this.charges) {
          if (curCharge.shareScheme === ChargeConstants.NOT_SHARED.code) {
            if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
              for (const slaveJob of this.job.lclSlaves) {
                if (slaveJob.charges) {
                  for (const slaveCharge of slaveJob.charges) {
                    if (slaveCharge.shared && String(slaveCharge.shareRefNo) === String(curCharge.chargeId)) {
                      delUuids.push(slaveCharge.uuid)
                    }
                  }
                }
              }
            }
            curCharge.apportioned = 0
            modCharges.push(curCharge)
          } else {
            const lclSlaves = this.chargeMap.get(curCharge.uuid)
            // 对分摊之后的费用进行验证
            if (!this.singleValidate(curCharge, lclSlaves)) {
              loading.close()
              return
            }
            await this.setShareChargesMulti(curCharge, lclSlaves, modCharges, delUuids)
            if (this.shareNature === 0) {
              curCharge.apportioned = 1
              modCharges.push(curCharge)
            } else {
              delUuids.push(curCharge.uuid)
            }
          }
        }
        data.chargeVOS = modCharges
        data.delChargeUuids = delUuids
      } else {
        if (this.charge.shareScheme === ChargeConstants.NOT_SHARED.code) {
          if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
            for (const slaveJob of this.job.lclSlaves) {
              if (slaveJob.charges) {
                for (const slaveCharge of slaveJob.charges) {
                  if (slaveCharge.shared && String(slaveCharge.shareRefNo) === String(this.charge.chargeId)) {
                    delUuids.push(slaveCharge.uuid)
                  }
                }
              }
            }
          }
          this.charge.apportioned = 0
          modCharges.push(this.charge)
        } else {
          // 手动分摊
          // 对分摊之后的费用进行验证
          if (!this.validate(true)) {
            loading.close()
            return
          }
          await this.setShareChargesSingle(modCharges, delUuids)
          if (this.shareNature === 0) {
            this.charge.apportioned = 1
            modCharges.push(this.charge)
          } else {
            delUuids.push(this.charge.uuid)
          }
        }
      }
      if (parseInt(cache.config.get('AutomaticFeeToSubJob')) === 1 && this.job.automaticAllocation) {
        loading.close()
        await this.$confirm(this.$t('CargoMsg.Cargo_TurnOffAutomaticAllocation'), this.$t('common.tips.confirm'), { type: 'warning' })
      }
      if (!loading) {
        loading = getLoading4Cxt(this)
      }
      data.slaveJobs = this.job.lclSlaves
      data.chargeVOS = modCharges
      data.delChargeKeys = delUuids
      // 只更新job分摊费用等信息
      data.location = this.location
      chargeShare(data).then(res => {
        this.$emit('chargeShared')
        this.innerVisible = false
      }).catch(() => {
      }).finally(() => {
        loading.close()
      })
    },
    // 单笔费用验证
    singleValidate(charge, lclSlaves) {
      if (charge && charge.shareScheme !== Number(ChargeConstants.NOT_SHARED.code)) {
        let total = 0 // 含税价
        let taxAmountTotal = 0 // 税额
        let exTaxAmountTotal = 0 // 不含税价
        let totalQuantity = 0 // 数量
        if (lclSlaves && lclSlaves.length > 0) {
          for (const job of lclSlaves) {
            if (!isNaN(job.shareAmount)) {
              total += Number(job.shareAmount)
            }
            if (!isNaN(job.shareTaxAmount)) {
              taxAmountTotal += Number(job.shareTaxAmount)
            }
            if (!isNaN(job.shareExcludingTaxAmount)) {
              exTaxAmountTotal += Number(job.shareExcludingTaxAmount)
            }
            if (!isNaN(job.shareQuantity)) {
              totalQuantity += Number(job.shareQuantity)
            }
          }
        }
        if (Math.abs(charge.amount - total) > 0.1) {
          this.$message.error(this.$t('CargoMsg.Cargo_ShareChargeCheck'))
          return false
        }
        if (Math.abs(charge.amount - total) !== 0) {
          // CARGO-8744 主票分摊给小票有0.01的误差
          const j = lclSlaves[0]
          j.shareAmount = roundHalfUp(j.shareAmount + (charge.amount - total), 2)
        }
        if (Math.abs(charge.taxAmount - taxAmountTotal) !== 0) {
          const amount = lclSlaves[0].shareTaxAmount
          lclSlaves[0].shareTaxAmount = roundHalfUp(amount + (charge.taxAmount - taxAmountTotal), 2)
        }
        if (Math.abs(charge.excludingTaxAmount - exTaxAmountTotal) !== 0) {
          const amount = lclSlaves[0].shareExcludingTaxAmount
          lclSlaves[0].shareExcludingTaxAmount = roundHalfUp(amount + (charge.excludingTaxAmount - exTaxAmountTotal), 2)
        }
        if (Math.abs(charge.quantity - totalQuantity) !== 0) {
          const quantity = lclSlaves[0].shareQuantity
          lclSlaves[0].shareQuantity = roundHalfUp(quantity + (charge.quantity - totalQuantity), 2)
        }
      }
      return true
    },
    async setShareChargesMulti(curCharge, lclSlaves, modCharges, delUuids) {
      const arTotalGroup = new ChargeCurrencyTotalGroup()
      const apTotalGroup = new ChargeCurrencyTotalGroup()
      if (lclSlaves && lclSlaves.length > 0) {
        for (const job of lclSlaves) {
          let charge
          if (job.charges && job.charges.length > 0) {
            for (const c of job.charges) {
              // 原来就是分摊的费用，则进行修改操作
              if (c.shared && String(c.shareRefNo) === String(curCharge.chargeId)) {
                charge = c
                break
              }
            }
          }
          const localCurrency = RateUtil.localCurrencyByOfficeId(job.opOffice)
          // CARGO-320，主票业务，费用页签，费用分摊功能，无法分摊负数金额
          if (!charge && job.shareAmount !== 0) {
            charge = new Charge().fillDefaultValue().getData()
            charge.branchId = job.opOffice
            if (parseInt(cache.config.get('CurrentOfficeCharge')) === 1 && job.salesOffice) {
              charge.branchId = job.salesOffice
            }
            charge.receivable = curCharge.receivable
            charge.chargeItemId = curCharge.chargeItemId
            charge.currency = curCharge.currency
            charge.measure = curCharge.measure

            charge.amount = NumberUtils.ToFixed2(job.shareAmount, 2)
            charge.quantity = job.shareQuantity
            charge.excludingTaxAmount = NumberUtils.ToFixed2(job.shareExcludingTaxAmount, 2)
            charge.taxAmount = NumberUtils.ToFixed2(job.shareTaxAmount, 2)
            charge.exchangeRate = curCharge.exchangeRate
            charge.taxRate = curCharge.taxRate
            charge.unitRate = curCharge.unitRate
            charge.unitPriceIncludeTax = curCharge.unitPriceIncludeTax
            charge.accountingDate = curCharge.accountingDate

            charge.oversea = curCharge.oversea
            if (this.shareNature === 0) {
              charge.shared = true
              charge.shareRefNo = curCharge.chargeId
            } else {
              charge.chargeSource = 13
            }
            charge.businessDate = job.businessDate

            charge.jobUuid = job.uuid
            // 如果原费用全部核销，则新生成的分摊费用要变更核销状态
            if (curCharge.verifiedAmount > 0 && curCharge.amount === curCharge.verifiedAmount && curCharge.paidOff) {
              charge.paidOff = true
            }
            charge.invoiceTitle = curCharge.invoiceTitle || ''
            // CARGO-30749 小票上费用存在分摊费用，复制该小票后，删除这笔分摊费用，保存业务后，会重新生成一笔与已其他费用相同的一笔费用
            charge.serialNumber = ChargeUtils.getMaxSerialNumber(job.charges, charge.receivable)
            // CARGO-37507 分摊费用受控的逻辑调整
            charge.controlled = curCharge.controlled
            // CARGO-45243 费用提交审核之后，主票分摊费用不会将状态同步到小票分摊费用上
            charge.chargeState = curCharge.chargeState
            charge.accountId = this.getShareAccountId(job, curCharge)
            if (curCharge.receivable) {
              // 结算对象变更后联动变更开票抬头”、“结算代理”、“国内国外
              await this.shareDetailAccountIdChange(charge)
            }
            modCharges.push(charge)
          } else if (charge && job.shareAmount !== 0) {
            charge.amount = NumberUtils.ToFixed2(job.shareAmount, 2)
            charge.quantity = job.shareQuantity
            charge.excludingTaxAmount = NumberUtils.ToFixed2(job.shareExcludingTaxAmount, 2)
            charge.taxAmount = NumberUtils.ToFixed2(job.shareTaxAmount, 2)
            charge.exchangeRate = curCharge.exchangeRate
            charge.taxRate = curCharge.taxRate
            charge.unitRate = curCharge.unitRate
            charge.unitPriceIncludeTax = curCharge.unitPriceIncludeTax
            charge.accountingDate = curCharge.accountingDate

            charge.businessDate = job.businessDate
            // 如果原费用全部核销，则新生成的分摊费用要变更核销状态
            if (curCharge.verifiedAmount > 0 && curCharge.amount === curCharge.verifiedAmount && curCharge.paidOff) {
              charge.paidOff = true
            }
            charge.invoiceTitle = curCharge.invoiceTitle || ''
            charge.chargeState = curCharge.chargeState
            charge.accountId = this.getShareAccountId(job, curCharge)
            if (this.shareNature !== 0) {
              charge.shared = false
              charge.shareRefNo = ''
              charge.chargeSource = 13
            }
            if (curCharge.receivable) {
              await this.shareDetailAccountIdChange(charge)
            }
            modCharges.push(charge)
          } else if (charge && job.shareAmount === 0) {
            charge.jobUuid = ''
            delUuids.push(charge.uuid)
          }
          // 预估利润
          // 开了isBookingFeeMandatoryAppliedGlobally参数，业务状态 非待审核或者拒绝，就不验证
          const isBookingFeeMandatoryAppliedGlobally = Number(cache.config.get('isBookingFeeMandatoryAppliedGlobally')) === 0
          if (parseInt(cache.config.get('saveCharge')) === 1 && charge && charge.jobUuid && isBookingFeeMandatoryAppliedGlobally) {
            // 应收
            if (job.estimateAccountsReceivable === 0) {
              arTotalGroup.dataField = parseInt(cache.config.get('chargeCalculateAmount')) === 1 ? 'amount' : 'excludingTaxAmount'
              arTotalGroup.amountToCurrency = localCurrency
              arTotalGroup.rateField = 'exchangeRate'
              arTotalGroup.isGrossProfit = true
              arTotalGroup.type = 'ar'
              arTotalGroup.dataProvider = job.charges
              await arTotalGroup.groupingCalc()
              const costRMB = arTotalGroup.getAmountByCurrency(localCurrency)
              const costUSD = arTotalGroup.getAmountByCurrency('USD') * charge.exchangeRate
              job.estimateAccountsReceivable = costRMB + costUSD
            }
            // 应付
            if (job.estimateAccountsPayable === 0) {
              apTotalGroup.amountToCurrency = localCurrency
              apTotalGroup.dataField = parseInt(cache.config.get('chargeCalculateAmount')) === 1 ? 'amount' : 'excludingTaxAmount'
              apTotalGroup.rateField = 'exchangeRate'
              apTotalGroup.isGrossProfit = true
              apTotalGroup.type = 'ap'
              apTotalGroup.dataProvider = (job.charges || []).filter(c => !c.businessSpecial) // 商务特殊费用不参与预估应付
              await arTotalGroup.groupingCalc()
              const sellingRMB = apTotalGroup.getAmountByCurrency(localCurrency)
              const sellingUSD = apTotalGroup.getAmountByCurrency('USD') * charge.exchangeRate
              job.estimateAccountsPayable = sellingRMB + sellingUSD
            }
            // 总预估
            job.estimateGrossProfit = job.estimateAccountsReceivable - job.estimateAccountsPayable
          }
        }
      }
    },
    async setShareChargesSingle(modCharges, delUuids) {
      const arTotalGroup = new ChargeCurrencyTotalGroup()
      const apTotalGroup = new ChargeCurrencyTotalGroup()
      if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
        for (const job of this.job.lclSlaves) {
          let charge
          if (job.charges && job.charges.length > 0) {
            for (const c of job.charges) {
              // 原来就是分摊的费用，则进行修改操作
              if (c.shared && String(c.shareRefNo) === String(this.charge.chargeId)) {
                charge = c
                break
              }
            }
          }
          const localCurrency = RateUtil.localCurrencyByOfficeId(job.opOffice)
          // CARGO-320，主票业务，费用页签，费用分摊功能，无法分摊负数金额
          if (!charge && job.shareAmount !== 0) {
            charge = new Charge().fillDefaultValue().getData()
            charge.branchId = job.opOffice
            if (parseInt(cache.config.get('CurrentOfficeCharge')) === 1 && job.salesOffice) {
              charge.branchId = job.salesOffice
            }
            charge.receivable = this.charge.receivable
            charge.chargeItemId = this.charge.chargeItemId
            charge.currency = this.charge.currency
            charge.measure = this.charge.measure

            charge.amount = NumberUtils.ToFixed2(job.shareAmount, 2)
            charge.quantity = job.shareQuantity
            charge.excludingTaxAmount = NumberUtils.ToFixed2(job.shareExcludingTaxAmount, 2)
            charge.taxAmount = NumberUtils.ToFixed2(job.shareTaxAmount, 2)
            charge.exchangeRate = this.charge.exchangeRate
            charge.taxRate = this.charge.taxRate
            charge.unitRate = this.charge.unitRate
            charge.unitPriceIncludeTax = this.charge.unitPriceIncludeTax
            charge.accountingDate = this.charge.accountingDate

            charge.oversea = this.charge.oversea
            if (this.shareNature === 0) {
              charge.shared = true
              charge.shareRefNo = this.charge.chargeId
            } else {
              charge.chargeSource = 13
            }
            charge.businessDate = job.businessDate
            charge.jobUuid = job.uuid
            // 如果原费用全部核销，则新生成的分摊费用要变更核销状态
            if (this.charge.verifiedAmount > 0 && this.charge.amount === this.charge.verifiedAmount && this.charge.paidOff) {
              charge.paidOff = true
            }
            // CARGO-30749 小票上费用存在分摊费用，复制该小票后，删除这笔分摊费用，保存业务后，会重新生成一笔与已其他费用相同的一笔费用
            charge.serialNumber = ChargeUtils.getMaxSerialNumber(job.charges, charge.receivable)
            charge.invoiceTitle = this.charge.invoiceTitle || ''
            charge.controlled = this.charge.controlled
            charge.chargeState = this.charge.chargeState
            if (this.charge.shareScheme === ChargeConstants.SHARE_HANDWORK.code) { // 手动分配的时候，费用结算对象取原费用的结算单位
              charge.accountId = this.charge.accountId
              // if (this.shareNature === 0 && charge.receivable) {
              //   charge.accountId = this.shareChargeAccountId(this.charge, job)
              //   if (charge.accountId !== this.charge.accountId) {
              //     // 结算对象变更后联动变更开票抬头”、“结算代理”、“国内国外
              //     await this.shareDetailAccountIdChange(charge)
              //   }
              // }
              if (this.shareNature === 1 && charge.receivable) {
                charge.accountId = job.customerId
                if (charge.accountId !== this.charge.accountId) {
                  // 结算对象变更后联动变更开票抬头”、“结算代理”、“国内国外
                  await this.shareDetailAccountIdChange(charge)
                }
              }
            } else {
              charge.accountId = this.getShareAccountId(job, this.charge)
              if (charge.receivable) {
                // 结算对象变更后联动变更开票抬头”、“结算代理”、“国内国外
                await this.shareDetailAccountIdChange(charge)
              }
            }
            modCharges.push(charge)
          } else if (charge && job.shareAmount !== 0) {
            charge.amount = NumberUtils.ToFixed2(job.shareAmount, 2)
            charge.quantity = job.shareQuantity
            charge.excludingTaxAmount = NumberUtils.ToFixed2(job.shareExcludingTaxAmount, 2)
            charge.taxAmount = NumberUtils.ToFixed2(job.shareTaxAmount, 2)
            charge.exchangeRate = this.charge.exchangeRate
            charge.taxRate = this.charge.taxRate
            charge.unitRate = this.charge.unitRate
            charge.unitPriceIncludeTax = this.charge.unitPriceIncludeTax
            charge.accountingDate = this.charge.accountingDate

            charge.businessDate = job.businessDate
            // 如果原费用全部核销，则新生成的分摊费用要变更核销状态
            if (this.charge.verifiedAmount > 0 && this.charge.amount === this.charge.verifiedAmount && this.charge.paidOff) {
              charge.paidOff = true
            }
            charge.accountId = this.getShareAccountId(job, this.charge)
            if (this.shareNature !== 0) {
              charge.shared = false
              charge.shareRefNo = ''
              charge.chargeSource = 13
            }
            if (charge.receivable) {
              // 结算对象变更后联动变更开票抬头”、“结算代理”、“国内国外
              await this.shareDetailAccountIdChange(charge)
            }
            charge.invoiceTitle = this.charge.invoiceTitle || ''
            charge.chargeState = this.charge.chargeState
            modCharges.push(charge)
          } else if (charge && job.shareAmount === 0) {
            charge.jobUuid = ''
            delUuids.push(charge.uuid)
          }
          // 预估利润
          // 开了isBookingFeeMandatoryAppliedGlobally参数，业务状态 非待审核或者拒绝，就不验证
          const isBookingFeeMandatoryAppliedGlobally = Number(cache.config.get('isBookingFeeMandatoryAppliedGlobally')) === 0
          if (parseInt(cache.config.get('saveCharge')) === 1 && charge && charge.jobUuid && isBookingFeeMandatoryAppliedGlobally) {
            // 应收
            if (job.estimateAccountsReceivable === 0) {
              arTotalGroup.dataField = parseInt(cache.config.get('chargeCalculateAmount')) === 1 ? 'amount' : 'excludingTaxAmount'
              arTotalGroup.amountToCurrency = localCurrency
              arTotalGroup.rateField = 'exchangeRate'
              arTotalGroup.isGrossProfit = true
              arTotalGroup.type = 'ar'
              arTotalGroup.dataProvider = job.charges
              await arTotalGroup.groupingCalc()
              const costRMB = arTotalGroup.getAmountByCurrency(localCurrency)
              const costUSD = arTotalGroup.getAmountByCurrency('USD') * charge.exchangeRate
              job.estimateAccountsReceivable = costRMB + costUSD
            }
            // 应付
            if (job.estimateAccountsPayable === 0) {
              apTotalGroup.amountToCurrency = localCurrency
              apTotalGroup.dataField = parseInt(cache.config.get('chargeCalculateAmount')) === 1 ? 'amount' : 'excludingTaxAmount'
              apTotalGroup.rateField = 'exchangeRate'
              apTotalGroup.isGrossProfit = true
              apTotalGroup.type = 'ap'
              apTotalGroup.dataProvider = (job.charges || []).filter(c => !c.businessSpecial) // 商务特殊费用不参与预估应付
              await arTotalGroup.groupingCalc()
              const sellingRMB = apTotalGroup.getAmountByCurrency(localCurrency)
              const sellingUSD = apTotalGroup.getAmountByCurrency('USD') * charge.exchangeRate
              job.estimateAccountsPayable = sellingRMB + sellingUSD
            }
            // 总预估
            job.estimateGrossProfit = job.estimateAccountsReceivable - job.estimateAccountsPayable
          }
        }
      }
      // CARGO-35073 主票分摊费用给小票，开票抬头的显示问题
      // if (modCharges && modCharges.length > 0) {
      //   await ChargeUtils.updateDefaultInvoiceTitle(modCharges)
      // }
    },
    shareChargeAccountId(charge, job) {
      let accountId = job.customerId
      const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
      if (chargeItem) {
        if (chargeItem.defaultArAccountId > 0) {
          accountId = chargeItem.defaultArAccountId
        } else if (chargeItem.defaultArAccountId <= 0 && chargeItem.defaultArCode) {
          accountId = ChargeUtils.getChargeDefaultChargeItem(job, chargeItem.defaultArCode)
        }
      }
      return accountId > 0 ? accountId : charge.accountId
    },
    onCellAccountId(params) {
      const data = params.data
      if (this.shareSelectedRow && this.slaveJobChargeAccountsMap.has(this.shareSelectedRow.uuid)) {
        const shareChargeMap = this.slaveJobChargeAccountsMap.get(this.shareSelectedRow.uuid)
        shareChargeMap.set(data.uuid, params.newValue)
      }
    },
    async shareDetailAccountIdChange(charge) {
      const oldInvoceTitle = charge.invoiceTitle
      // 修改结算对象修改关联信息
      await this.accountIdChange(charge, this.currentViewCacheData)
      // 加载开票抬头
      await this.getTitlesByCompanyId(charge)
      if (charge.invoiceTitle) {
        if (charge.invoiceTitle !== oldInvoceTitle) {
          const flag = ChargeUtils.updateOverseaByInvoiceTitle(charge, this.getInvoiceTitleList(charge.accountId))
          if (!flag && charge.invoiceTitle !== oldInvoceTitle && charge.accountId > 0) {
            await ChargeUtils.updateOverseaByAccountId(charge)
          }
        }
      } else if (charge.accountId > 0) {
        await ChargeUtils.updateOverseaByAccountId(charge)
      }
    },
    async accountIdChange(cost, currentViewCacheData) {
      const canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))
      const chargeAuto = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', cost.accountId)
      if (chargeAuto && cost) {
        cost.accountId = chargeAuto.cmpIdx
        await ChargeUtils.getChargeisOverseaNotControlledByConfigIgnoreTaxRate(cost)
        const c = await Company.getCompanyById(cost.accountId)
        if (c) {
          cost.oversea = (c.designationAgent || c.overseaAgent) // 指定货代理/目的港代理
          if (canChangeOverseaOfCharge === 2) {
            cost.oversea = false
          } else if (canChangeOverseaOfCharge === 3) {
            cost.oversea = true
          }
          if (cost.accountId > 0) {
            await ChargeColumnUtil.getInvoiceTitle(cost)
          }
        }
        await ChargeColumnUtil.getSettlementByCompanyId(cost, currentViewCacheData)
      }
    },
    async getTitlesByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      if (this.currentViewCacheData.customerTitlesMap.has(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId)
      }
      // 获取数据库中维护的开票抬头
      const res = await queryTitleByCpmIdx(accountId)
      let dbTitles = res.data
      if (!dbTitles) dbTitles = []
      if (dbTitles.length > 0) {
        for (const title of dbTitles) {
          if (!title.title) continue
          title.invoiceTitle = title.title
        }
      }
      this.currentViewCacheData.customerTitlesMap.set(accountId, dbTitles)
      return this.currentViewCacheData.customerTitlesMap.get(accountId)
    },
    getInvoiceTitleList(accountId) {
      if (this.currentViewCacheData.customerTitlesMap.get(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId).reduce((res, item) => {
          if (!res.find(re => re.invoiceTitle === item.invoiceTitle && re.taxAccount === item.taxAccount)) {
            res.push(item)
          }
          return res
        }, [])
      }
      return []
    },
    loadSlaveJobChargeAccountsMap() {
      this.slaveJobChargeAccountsMap = new Map()
      const chargeAccountMap = new Map()
      if (this.charges && this.charges.length > 0) {
        for (const charge of this.charges) {
          chargeAccountMap.set(charge.uuid, charge.accountId)
        }
        if (this.job.masterFlag && this.job.lclSlaves) {
          for (const job of this.job.lclSlaves) {
            this.slaveJobChargeAccountsMap.set(job.uuid, lodash.cloneDeep(chargeAccountMap))
          }
        }
      }
    },
    setSlaveChargeShareAccountId(slaveJob, charge) {
      const chargeAccountsMap = this.slaveJobChargeAccountsMap.get(slaveJob.uuid)
      if (chargeAccountsMap) {
        if (charge.receivable) {
          if (this.shareNature === 0) {
            // chargeAccountsMap.set(charge.uuid, this.shareChargeAccountId(charge, slaveJob))
            chargeAccountsMap.set(charge.uuid, charge.accountId)
          } else {
            chargeAccountsMap.set(charge.uuid, slaveJob.customerId)
          }
        } else {
          chargeAccountsMap.set(charge.uuid, charge.accountId)
        }
      }
    },
    getShareAccountId(job, charge) {
      const shareAccountMap = this.slaveJobChargeAccountsMap.get(job.uuid)
      if (shareAccountMap && shareAccountMap.has(charge.uuid)) {
        return shareAccountMap.get(charge.uuid)
      }
      return charge.accountId
    }
  }
}
</script>

<style lang="scss">
.charge-share-dialog {
  .charge-share-dialog-inner {
    .el-form-item__label {
      padding-right: 0;
    }
    .el-form .el-form-item .el-form-item__content {
      .el-radio {
        margin-right: 5px;
      }
    }
    .el-card {
      margin: 10px 0;
      position: relative;
      overflow: unset;
      &__header {
        position: absolute;
        display: inline-block;
        padding: 0 10px;
        margin-left: 10px;
        transform: translateY(-50%);
        border: none;
        background: #fff;
      }
      &__body {
        padding: 15px 10px 10px 10px;
      }
    }
  }
}
</style>
